// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1wpz1fhb{align-self:stretch}\n._1wyb1skh{font-size:11px}\n._ect41gqc{font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}\n._slp31hna{word-wrap:break-word}\n._syaz1glm{color:var(--ds-text,grey)}", ""]);
// Exports
module.exports = exports;
